import {
	amber,
	blue,
	deepOrange,
	green,
	grey,
	indigo,
	purple,
	red,
	yellow,
} from '@mui/material/colors'
import dayjs from 'dayjs'
import config from '@configs'

// type
import { ReqType, ResType } from '@api'

export const Logger = {
	now: dayjs().format('YYYY-MM-DD HH:mm:ss.SSS') as any as string,
	log: (data: any) => {
		if (config.get('isDevEnv')) {
			console.log(data)
		}
	},
	warn: (data: any) => {
		if (config.get('isDevEnv')) {
			console.warn(data)
		}
	},
	error: (data: any) => {
		if (config.get('isDevEnv')) {
			console.error(data)
		}
	},
	env: () => {
		if (config.get('isDevEnv')) {
			const systemEnv: { [key: string]: string } = { ...config.get('system') }
			const apiEnv: { [key: string]: string } = config.get('api')
			const envColor = config.get('isDevEnv') ? deepOrange[500] : indigo[500]

			console.log(
				`%c⏱️ ${systemEnv.name.replaceAll(/-/g, ' ')} 💰 START!🚀`,
				`padding: 0.3rem 1.5rem; font-family: Roboto; font-size: 1.2em; line-height: 1.4em; color: white; background-color: #4158D0; background-image: linear-gradient(43deg, ${indigo[500]} 0%, ${purple[400]} 46%, ${amber[200]} 100%); font-weight: bold ;font-size: 50px; border-radius: 10px`,
			)

			console.group(
				'%c APP ENV --------------------------------- ',
				`background: ${grey[700]}; color: #FFF`,
			)

			Object.keys(systemEnv).map((aEnv: string) => {
				const value = systemEnv[aEnv]
				console.log(`system ${aEnv}: %c${value}`, `color: ${envColor}; font-weight: 900`)
			})

			Object.keys(apiEnv).map((aEnv: string) => {
				const value = apiEnv[aEnv]
				console.log(`api ${aEnv}: %c${value}`, `color: ${envColor}; font-weight: 900`)
			})

			console.groupEnd()
			console.log(
				'%c --------------------------------- APP ENV ',
				`background: ${grey[700]}; color: #FFF`,
			)
		}
	},

	api: (statusStr: string, req: ReqType, res: ResType) => {
		if (config.get('isDevEnv')) {
			const statusColor =
				statusStr === 'success'
					? green[600]
					: statusStr === 'fail'
					? red[800]
					: statusStr === 'error'
					? red[800]
					: '#000'

			const methodColor =
				req.method === 'get'
					? blue[800]
					: req.method === 'post'
					? green[600]
					: req.method === 'put'
					? yellow[800]
					: red[800]

			console.group(
				`%c API %c ${statusStr.toUpperCase()} ${res.status} %c @ ${Logger.now}`,
				'background: #5641d7; color: #FFF',
				`background: ${statusColor}; color: #FFF`,
				'color: #888; font-weight: 500',
			)
			console.log(
				`%c status: %c ${res.status}`,
				'color: #6f6f6f',
				`color: ${statusColor}; font-weight: 900`,
			)
			console.log(
				`%c method: %c ${req.method.toUpperCase()}`,
				'color: #6f6f6f',
				`color: ${methodColor}`,
			)
			console.log(
				`%c uri: %c${req.uri}`,
				'color: #6f6f6f',
				`color: ${methodColor}; font-weight: 900`,
			)

			if (typeof req.query !== 'undefined') {
				console.log('%c query: ', 'color: #6f6f6f', req.query)
			}

			if (typeof req.body !== 'undefined') {
				console.log('%c body: ', 'color: #6f6f6f', req.body)
			}

			if (statusStr === 'fail' || statusStr === 'error') {
				console.log('%c exception: ', 'color: #6f6f6f', res.exception)
			}

			console.log('%c headers: ', 'color: #6f6f6f', req.headers)

			console.log('%c result: ', 'color: #6f6f6f', res.data)

			if (statusStr != 'success') console.log('%c config: ', 'color: #6f6f6f', res.config)

			console.groupEnd()
		}
	},

	path: (path: string) => {
		if (config.get('isDevEnv')) {
			console.log(
				`%c PATH %c ${path} %c @ ${Logger.now}`,
				'background: #00255B; color: #00FFA1',
				'background: #ffd3e6; color: #5f1293; font-weight: 900',
				'color: #888',
			)
		}
	},

	fcmToken: (fcmToken: string, userId: string) => {
		console.log(
			`%c ISSUED FCM TOKEN: %c\n token: %c\n\t ${fcmToken} %c\n user: ${userId}`,
			'background: #466380; color: #FFF',
			'color: #6f6f6f',
			'color: #466380; font-weight: bold',
			'color: #6f6f6f',
		)
	},

	imagePicker: (status: string, method: string, isCrop: boolean, result?: any) => {
		if (config.get('isDevEnv')) {
			const statusColor =
				status === 'success'
					? '#009e4a'
					: status === 'clean-up'
					? '#0052bd'
					: status === 'error'
					? '#d61500'
					: '#000'

			const modeStr = isCrop ? 'Crop' : 'Normal'

			console.group(
				`%c IMAGE PICKER %c ${status.toUpperCase()} %c @ ${Logger.now}`,
				'background: #ff7100; color: #FFF',
				`background: ${statusColor}; color: #FFF`,
				'color: #888; font-weight: 500',
			)

			console.log(
				`%c method: %c${method}`,
				'color: #6f6f6f',
				`color: ${statusColor}; font-weight: 900`,
			)

			console.log(
				`%c mode: %c${modeStr}`,
				'color: #6f6f6f',
				`color: ${statusColor}; font-weight: 900`,
			)

			if (typeof result !== 'undefined') {
				if (status == 'success') {
					console.log('%c result:', 'color: #6f6f6f', result)
				} else {
					console.log('%c error:', 'color: #6f6f6f', result)
				}
			}

			console.groupEnd()
		}
	},
}
